/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'tools.ozone.verification.revokeVerifications'

export { $nsid }

/** Revoke previously granted verifications in batches of up to 100. */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    uris: l.array(l.string({ format: 'at-uri' }), { maxLength: 100 }),
    revokeReason: l.optional(l.string({ maxLength: 1000 })),
  }),
  l.jsonPayload({
    revokedVerifications: l.array(l.string({ format: 'at-uri' })),
    failedRevocations: l.array(l.ref<RevokeError>((() => revokeError) as any)),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output

/** Error object for failed revocations */
type RevokeError = {
  $type?: 'tools.ozone.verification.revokeVerifications#revokeError'

  /**
   * The AT-URI of the verification record that failed to revoke.
   */
  uri: l.AtUriString

  /**
   * Description of the error that occurred during revocation.
   */
  error: string
}

export type { RevokeError }

/** Error object for failed revocations */
const revokeError = l.typedObject<RevokeError>(
  $nsid,
  'revokeError',
  l.object({ uri: l.string({ format: 'at-uri' }), error: l.string() }),
)

export { revokeError }
